export default {
  'pages.login.title': '登录',
  'pages.login.brand': 'Liulian AI',
  'pages.login.subtitle': '下一代 AI 创作平台',
  'pages.login.accountLogin.tab': '账号密码登录',
  'pages.login.emailLogin.tab': '邮箱验证码登录',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '请输入用户名',
  'pages.login.username.length': '用户名长度为 4-15 位',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入密码',
  'pages.login.password.length': '密码长度为 4-20 位',
  'pages.login.email.placeholder': '邮箱',
  'pages.login.email.required': '请输入邮箱',
  'pages.login.email.invalid': '邮箱格式不正确',
  'pages.login.captcha.placeholder': '验证码',
  'pages.login.captcha.required': '请输入验证码',
  'pages.login.captcha.get': '获取验证码',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码',
  'pages.login.submit': '登录',
  'pages.login.registerSuccess': '注册成功，请登录',
  'pages.login.resetPasswordSuccess': '密码修改成功，请登录',
  'pages.login.success': '登录成功！',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.accountLogin.errorMessage': '账号或密码错误',
  'pages.login.emailLogin.errorMessage': '邮箱或验证码错误',
  'pages.login.backHome': '返回首页',
  'pages.login.captcha.sent': '验证码已发送至邮箱',
  'pages.login.captcha.sendFailed': '验证码发送失败，请稍后重试',
  'pages.login.noAccount': '还没有账户？ {register}',
  'pages.login.registerNow': '立即注册',
};
